<template>
	<projects-table v-if="active" :projects="projects" simplify title-bar>
		<create-project :client="client" />
	</projects-table>
</template>
<script>
import ProjectsTable from '@/Pages/Backend/Projects/Table'
import CreateProject from '@/Pages/Backend/Projects/Create'

export default {
	components: {
		ProjectsTable,
		CreateProject
	},
	props: {
		projects: {
			type: [Array, Object],
			default: () => {},
			required: true
		},
		active: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			client: this.$page.props.client
		}
	},
	watch: {
		active () {
			// Reset query string, so we don't confuse the other data tables
			window.history.pushState({}, document.title, window.location.pathname)
		}
	}
}
</script>
